import { render, staticRenderFns } from "./JumboButton.vue?vue&type=template&id=46e2e63f&scoped=true&"
import script from "./JumboButton.vue?vue&type=script&lang=js&"
export * from "./JumboButton.vue?vue&type=script&lang=js&"
import style0 from "./JumboButton.vue?vue&type=style&index=0&id=46e2e63f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e2e63f",
  null
  
)

export default component.exports